import { cn } from '@web/lib/shadcn';
import { HTMLAttributes } from 'react';

export function Media({
  file: { type, content },
  className,
}: HTMLAttributes<HTMLImageElement | HTMLVideoElement | HTMLObjectElement> & {
  file: {
    type: string;
    content: string;
  };
}) {
  const renderMedia = () => {
    if (type.startsWith('image/')) {
      return (
        <img
          src={`data:${type};base64,${content}`}
          className={cn(
            'max-h-[400px] w-auto sm:max-h-[350px] md:max-h-[350px]',
            className,
          )}
          alt="Media content"
        />
      );
    } else if (type.startsWith('video/')) {
      return (
        <video controls className={cn('', className)}>
          <source src={`data:${type};base64,${content}`} type={type} />
          Your browser does not support the video tag.
        </video>
      );
    } else if (type === 'application/pdf') {
      return (
        <object
          data={`data:${type};base64,${content}`}
          type={type}
          className={cn('', className)}
        ></object>
      );
    } else {
      return (
        <a
          href={`data:${type};base64,${content}`}
          download
          className={cn('', className)}
        >
          Download File
        </a>
      );
    }
  };

  return <div className={cn('', className)}>{renderMedia()}</div>;
}
